import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// OPUS clock override: shown when an operator starts a half whose clock is
// already running. Confirming emits a fresh clock_start so the clock restarts
// from when they clicked start (the original start stays in the event log).
const OverrideClockConfirmDialog = ({ open, periodLabel, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        backgroundColor: '#1E1E1E',
        borderRadius: 3,
        border: '1px solid rgba(255, 255, 255, 0.12)',
      },
    }}
  >
    <DialogTitle
      sx={{
        color: '#FFFFFF',
        fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
        fontSize: 20,
        fontWeight: 600,
        pb: 1,
      }}
    >
      Clock already running
    </DialogTitle>
    <DialogContent>
      <Box sx={{ mt: 1 }}>
        <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 14 }}>
          A clock is already running for{' '}
          <strong>{periodLabel || 'this period'}</strong>. Overriding restarts it
          from now (the moment you clicked start). The original start stays in the
          event log.
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} sx={{ color: 'rgba(255,255,255,0.7)', textTransform: 'none' }}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          backgroundColor: '#FCC144',
          color: '#000',
          fontWeight: 600,
          textTransform: 'none',
          '&:hover': { backgroundColor: '#e6ad33' },
        }}
      >
        Override &amp; Restart
      </Button>
    </DialogActions>
  </Dialog>
);

OverrideClockConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  periodLabel: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default OverrideClockConfirmDialog;
